import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-service-marketing-strategies',
  templateUrl: './service-marketing-strategies.component.html',
  styleUrls: ['./service-marketing-strategies.component.css']
})
export class ServiceMarketingStrategiesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
